import { createReducer, on } from "@ngrx/store";
import { ViewedBill } from "../../../models/bill.model";
import { billActions } from "../bill.actions";

export const initialState: ViewedBill|Object = {};

export const billsViewReducer = createReducer(
    initialState,
    on(billActions.viewBillSuccess, (state, {payload}) => payload),
    on(billActions.editBillExtractionSuccess, (state, {payload}) => payload),
    on(billActions.clearViewedBill, (state) => initialState)
)